import { ClientOnly } from 'remix-utils';
import type { DisplayMode } from '@rocco/types/enum/display-mode';
import type { SearchIndexes } from '@modules-rocco/search/types/enum/search-indexes';
import { CategorySearchIsland } from '@ui-rocco/floating-island/category-search-island';
import { useRootData } from '~/modules/root';

/**
 * Props interface for the CategoryPageSearchIsland component
 * @interface CategoryPageSearchIslandProps
 * @property {SearchIndexes} searchIndex - The search index to use for category search
 * @property {DisplayMode} displayMode - Current display mode (mobile/desktop)
 * @property {string[]} placeholders - Array of placeholder text options for the search input
 */
interface CategoryPageSearchIslandProps {
    searchIndex: SearchIndexes;
    displayMode: DisplayMode;
    placeholders: string[];
    scrollThreshold?: number;
}

/**
 * Component that renders a search island for category pages
 * Wraps CategorySearchIsland in ClientOnly to ensure client-side only rendering
 * Enables search modal toggle on click
 * @param {CategoryPageSearchIslandProps} props - Component props
 * @returns {JSX.Element} The rendered search island component
 */
export const CategoryPageSearchIsland = (
    props: CategoryPageSearchIslandProps
) => {
    const { device } = useRootData();
    // hide search island on mobile
    const { displayMode } = props;
    if (displayMode === 'mobile') {
        return null;
    }
    

    return (
        <ClientOnly fallback={<></>}>
            {() => (
                <CategorySearchIsland
                    {...props}
                    shouldAutoFocusOnVisible={device.type === 'desktop'}
                    toggleSearchModalOnClick={true}
                />
            )}
        </ClientOnly>
    );
};
